import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { adminLogin, setToken } from "../lib/api";

const AdminLoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await adminLogin(email, password);
      setToken(r.token);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white border border-border p-10">
        <Link to="/" className="block">
          <div className="font-serif text-2xl text-primary">Islands Escape</div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-muted-foreground mt-1">Admin Panel</div>
        </Link>
        <h1 className="font-serif text-3xl text-primary mt-8">Sign in</h1>
        <p className="text-sm text-muted-foreground mt-2">Manage your bookings, content & calendars.</p>

        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <input
            type="email"
            placeholder="Email"
            className="input-field"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            data-testid="admin-email"
          />
          <input
            type="password"
            placeholder="Password"
            className="input-field"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            data-testid="admin-password"
          />
          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="admin-login-submit">
            {loading ? <><Loader2 size={14} className="animate-spin" /> Signing in…</> : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLoginPage;
